module.exports = __webpack_public_path__ + "static/media/IMG_0049.c7a77949.jpg";